module.exports = __webpack_public_path__ + "images/certificate_icon.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/certificate_icon.jpg
// module id = 750
// module chunks = 0